import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TicketInviteModel, TicketService, TicketValidateModel } from '@fgb/core';

@Component({
  selector: 'fgbcl-ticket-invite',
  templateUrl: './ticket-invite.component.html',
  styleUrls: ['./ticket-invite.component.scss'],
})

export class TicketInviteComponent implements OnInit {
  response: any;
  errorMessage: string;
  validateCredentials: boolean = true;
  showTicketList: boolean = false;
  ticketInvideList: TicketInviteModel[] = [];
  codeErrorKey: string;
  ticketInviteProcess: boolean = true;
  constructor(private formBuilder: UntypedFormBuilder, private ticketService: TicketService) {}
  form: UntypedFormGroup;
  submitted: boolean = false;
  @Input() ticketKey = '';

  ngOnInit(): void {
    this.ticketInviteForm();
  }

  ticketInviteForm() {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$')]],
      uniqueCode: ['', [Validators.required]],
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  /*get email and code and call validateTicketInviteCredentials to check the Credentials*/
  onSubmit() {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    const ticketInviteParasm: TicketValidateModel = {
      emailAddress: this.f['email'].value,
      uniqKey: this.f['uniqueCode'].value,
      ticketKey: this.ticketKey,
    };

    this.ticketService.validateTicketInviteCredentials(ticketInviteParasm).subscribe({
      next: (res) => {
        this.ticketInvideList = res;
        this.codeErrorKey = '';
        this.validateCredentials = true;
        this.showTicketList = true;
      },
      error: (error: HttpErrorResponse) => {
        if (error.status == 400) {
          this.codeErrorKey = String(error.error.Code).toLowerCase();
          this.validateCredentials = false;
          this.showTicketList = false;
        }
      },
    });
  }

  ticketProcess() {
    const ticketInviteParasm: TicketValidateModel = {
      emailAddress: this.f['email'].value,
      uniqKey: this.f['uniqueCode'].value,
      ticketKey: this.ticketKey,
    };

    this.ticketService.ticketTransferprocess(ticketInviteParasm).subscribe({
      next: () => {
        this.ticketInviteProcess = true;
        this.codeErrorKey = '';
      },
      error: (error: HttpErrorResponse) => {
        this.ticketInviteProcess = false;
        if (error.status == 400) {
          this.codeErrorKey = String(error.error.Code).toLowerCase();
        }
      },
    });
  }

}
